import { TableHeaderCell } from 'common/components';

export type SourceFilterOption = { value: string; label: string };

type SourceFilterCellProps = {
    filterSource: string;
    sourceOptions: SourceFilterOption[];
    onFilterSource: (value: string) => void;
};

export const SourceFilterCell = ({ filterSource, sourceOptions, onFilterSource }: SourceFilterCellProps) => {
    const options = [{ value: '', label: 'All sources' }, ...sourceOptions];
    const selectedValues = filterSource ? filterSource.split(',').filter(Boolean) : [];

    return (
        <TableHeaderCell
            label='Source'
            isSearchable
            filterOptions={{
                mode: 'multi',
                options,
                selectedValues,
                onChange: (values) => onFilterSource(values.join(',')),
            }}
        />
    );
};
